import { createStore } from 'easy-peasy'
import model from '../models'
 
export default createStore(model) 